import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AdminSidebar } from './AdminLeaderboardWinners';
import { Calendar, Users, Target, Ticket } from 'lucide-react';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/admin/dashboard`, { withCredentials: true });
        setStats(data);
      } catch (e) {
        // silent
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0B1020]" data-testid="admin-dashboard">
      <AdminSidebar active="/admin/dashboard" />

      <main className="lg:ml-64 p-4 lg:p-8 pt-20 lg:pt-8">
        <div className="mb-8">
          <h1 className="text-4xl font-black text-white mb-2">Dashboard</h1>
          <p className="text-gray-400">Selamat datang di panel admin EXTRA TIME</p>
        </div>

        {loading ? (
          <div className="text-white">Loading...</div>
        ) : stats ? (
          <>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <div className="glass-card p-6" data-testid="dash-matches">
                <Calendar className="text-[#FFD60A] mb-3" size={32} />
                <div className="text-3xl font-black text-white mb-1 tabular-nums">{stats.matches?.today || 0}</div>
                <div className="text-gray-400 text-sm">Pertandingan Hari Ini</div>
              </div>

              <div className="glass-card p-6" data-testid="dash-participants">
                <Users className="text-[#1D4ED8] mb-3" size={32} />
                <div className="text-3xl font-black text-white mb-1 tabular-nums">{stats.participants?.total || 0}</div>
                <div className="text-gray-400 text-sm">Total Partisipan</div>
              </div>

              <div className="glass-card p-6" data-testid="dash-predictions">
                <Target className="text-[#D90429] mb-3" size={32} />
                <div className="text-3xl font-black text-white mb-1 tabular-nums">{stats.predictions?.total || 0}</div>
                <div className="text-gray-400 text-sm">Total Prediksi</div>
              </div>

              <div className="glass-card p-6" data-testid="dash-tickets">
                <Ticket className="text-[#22C55E] mb-3" size={32} />
                <div className="text-3xl font-black text-white mb-1 tabular-nums">{stats.tickets?.total || 0}</div>
                <div className="text-gray-400 text-sm">Total Tiket</div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="glass-card p-6">
                <h3 className="text-xl font-bold text-white mb-4">Status Pertandingan</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Total</span>
                    <span className="text-white font-bold tabular-nums">{stats.matches?.total || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Mendatang</span>
                    <span className="text-white font-bold tabular-nums">{stats.matches?.upcoming || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Live</span>
                    <span className="text-red-400 font-bold tabular-nums">{stats.matches?.live || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Selesai</span>
                    <span className="text-green-400 font-bold tabular-nums">{stats.matches?.finished || 0}</span>
                  </div>
                </div>
              </div>

              <div className="glass-card p-6">
                <h3 className="text-xl font-bold text-white mb-4">Status Tiket & Konten</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Tiket Pending</span>
                    <span className="text-white font-bold tabular-nums">{stats.tickets?.pending || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Tiket Pemenang</span>
                    <span className="text-[#FFD60A] font-bold tabular-nums">{stats.tickets?.winner || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Tim Terdaftar</span>
                    <span className="text-white font-bold tabular-nums">{stats.teams || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Website Aktif</span>
                    <span className="text-white font-bold tabular-nums">{stats.websites || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Partner Aktif</span>
                    <span className="text-white font-bold tabular-nums">{stats.partners || 0}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </main>
    </div>
  );
};
